import styled from "styled-components";
import { Breadcrumb } from "semantic-ui-react";

export const StyledBreadcrumb = styled(Breadcrumb)`
  display: flex !important;
  margin-bottom: 32px !important;
`;
